export const GlamClub = {
  listStorefront: {
    url: "/glamclub/list",
    method: ["GET"],
    required: ["page", "pageSize", "searchKey"]
  },
  productTrade: {
    url: "/glamclub/product/trade?productVariantId={productVariantId}",
    method: ["POST"]
  }
};
